<div class="credentials-container">
  <div class="col-12">
    <div class="dashboard-header">
      <div class="header-content">
        <div class="header-title-section">
          <h1><i class="pi pi-shield"></i> Credentials API</h1>
          <p class="dashboard-subtitle">{{ credentials.length }} credential(s) configurée(s) &middot; {{ groupedCredentials.length }} utilisateur(s)</p>
        </div>
        <div class="header-actions">
          <p-button 
            [icon]="viewMode === 'grouped' ? 'pi pi-table' : 'pi pi-list'"
            (onClick)="toggleViewMode()"
            [disabled]="loading"
            styleClass="p-button-outlined p-button-secondary"
            [pTooltip]="viewMode === 'grouped' ? 'Vue Table' : 'Vue Groupée'"
            tooltipPosition="bottom">
          </p-button>
          <p-button 
            icon="pi pi-filter" 
            (onClick)="showUserFilterDialog = true"
            [disabled]="loading"
            styleClass="p-button-outlined p-button-secondary"
            pTooltip="Filtrer par utilisateur"
            tooltipPosition="bottom">
          </p-button>
          <p-button 
            icon="pi pi-refresh" 
            (onClick)="loadAllCredentials()"
            [disabled]="loading"
            [loading]="loading"
            styleClass="p-button-outlined p-button-secondary"
            pTooltip="Actualiser"
            tooltipPosition="bottom">
          </p-button>
          <p-button 
            icon="pi pi-plus" 
            (onClick)="showAddDialog = true"
            [disabled]="loading"
            styleClass="p-button-success"
            pTooltip="Nouvelle credential"
            tooltipPosition="bottom">
          </p-button>
        </div>
      </div>
    </div>

    <div class="table-container">



      <!-- Vue groupée par utilisateur -->
      <div *ngIf="viewMode === 'grouped'" class="grouped-view">
        <p-accordion>
          <p-accordionTab *ngFor="let group of groupedCredentials">
            <ng-template pTemplate="header">
              <div class="accordion-header-content">
                <div class="user-info-header">
                  <div class="user-avatar-cred">
                    {{ (group.username || '').charAt(0).toUpperCase() || 'U' }}
                  </div>
                  <div class="user-meta">
                    <span class="user-name-cred">{{ group.username }}</span>
                    <span class="user-email-cred">{{ group.email }}</span>
                  </div>
                  <p-tag [value]="group.totalCredentials + ' clé(s)'" 
                         severity="info" [rounded]="true" class="count-badge"></p-tag>
                </div>
                <div class="api-tags-header">
                  <p-tag *ngFor="let api of group.apis" 
                         [value]="api" 
                         [severity]="getSeverity(api)"
                         [rounded]="true">
                  </p-tag>
                </div>
              </div>
            </ng-template>

            <div class="credential-table-wrapper">
              <p-table [value]="group.credentials" styleClass="p-datatable-sm p-datatable-striped">
                <ng-template pTemplate="header">
                  <tr>
                    <th style="width: 15%">API</th>
                    <th style="width: 25%">Clé</th>
                    <th style="width: 35%">Valeur</th>
                    <th style="width: 25%">Actions</th>
                  </tr>
                </ng-template>

                <ng-template pTemplate="body" let-credential>
                  <tr>
                    <td>
                      <p-tag [value]="credential.api_name" 
                             [severity]="getSeverity(credential.api_name)"
                             [rounded]="true">
                      </p-tag>
                    </td>
                    <td>
                      <code class="credential-key">{{ credential.credential_key }}</code>
                    </td>
                    <td>
                      <div class="credential-value-cell">
                        <span class="credential-value-text">{{ credential.credential_value }}</span>
                        <p-button icon="pi pi-eye"
                                  pTooltip="Voir complète"
                                  tooltipPosition="top"
                                  (onClick)="viewFullCredential(credential)"
                                  [disabled]="loading"
                                  styleClass="p-button-text p-button-sm p-button-info">
                        </p-button>
                      </div>
                    </td>
                    <td>
                      <div class="action-buttons">
                        <p-button icon="pi pi-pencil"
                                  pTooltip="Modifier"
                                  tooltipPosition="top"
                                  (onClick)="editCredential(credential)"
                                  [disabled]="loading"
                                  styleClass="p-button-text p-button-sm p-button-warning">
                        </p-button>
                        <p-button icon="pi pi-trash"
                                  pTooltip="Supprimer"
                                  tooltipPosition="top"
                                  (onClick)="deleteCredential(credential)"
                                  [disabled]="loading"
                                  styleClass="p-button-text p-button-sm p-button-danger">
                        </p-button>
                      </div>
                    </td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
          </p-accordionTab>
        </p-accordion>
      </div>

      <!-- Vue table classique -->
      <div *ngIf="viewMode === 'table'">
        <p-table 
          [value]="credentials" 
          [loading]="loading"
          [paginator]="true" 
          [rows]="10"
          [showCurrentPageReport]="true"
          [globalFilterFields]="['api_name', 'credential_key', 'user.username', 'user.email']"
          #dt>
          
          <ng-template pTemplate="caption">
            <div class="flex justify-content-between align-items-center">
              <span class="text-xl text-900 font-bold">Credentials ({{ credentials.length }})</span>
              <span class="p-input-icon-left">
                <i class="pi pi-search"></i>
                <input 
                  pInputText 
                  type="text" 
                  (input)="onGlobalFilter($event, dt)" 
                  placeholder="Rechercher par nom, email, API ou clé..." />
              </span>
            </div>
          </ng-template>

          <ng-template pTemplate="header">
            <tr>
              <th pSortableColumn="user.username" style="width: 25%">
                Utilisateur <p-sortIcon field="user.username"></p-sortIcon>
              </th>
              <th pSortableColumn="api_name" style="width: 15%">
                API <p-sortIcon field="api_name"></p-sortIcon>
              </th>
              <th pSortableColumn="credential_key" style="width: 20%">
                Clé <p-sortIcon field="credential_key"></p-sortIcon>
              </th>
              <th style="width: 25%">Valeur</th>
              <th style="width: 15%">Actions</th>
            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-credential>
            <tr>
              <td>
                <div class="flex align-items-center gap-3">
                  <div class="bg-primary-100 p-2 border-round">
                    <i class="pi pi-user text-primary"></i>
                  </div>
                  <div>
                    <div class="font-bold text-900">
                      {{ credential.user?.username || 'Utilisateur ' + credential.user_id }}
                    </div>
                    <div class="text-600 text-sm">
                      <i class="pi pi-envelope mr-1"></i>
                      {{ credential.user?.email || 'Email non disponible' }}
                    </div>
                    <div class="text-500 text-xs mt-1">
                      <i class="pi pi-id-card mr-1"></i>
                      ID: {{ credential.user_id }}
                    </div>
                  </div>
                </div>
              </td>
              <td>
                <p-tag 
                  [value]="credential.api_name" 
                  [severity]="getSeverity(credential.api_name)">
                </p-tag>
              </td>
              <td>
                <span class="font-medium">{{ credential.credential_key }}</span>
              </td>
              <td>
                <div class="flex align-items-center gap-2">
                  <span class="text-600 font-mono">{{ credential.credential_value }}</span>
                  <p-button 
                    icon="pi pi-eye"
                    pTooltip="Voir la valeur complète"
                    tooltipPosition="top"
                    (onClick)="viewFullCredential(credential)"
                    [disabled]="loading"
                    severity="info"
                    [text]="true"
                    size="small">
                  </p-button>
                </div>
              </td>
              <td>
                <div class="flex gap-1">
                  <p-button 
                    icon="pi pi-pencil"
                    pTooltip="Modifier"
                    tooltipPosition="top"
                    (onClick)="editCredential(credential)"
                    [disabled]="loading"
                    severity="info"
                    [text]="true"
                    size="small">
                  </p-button>
                  <p-button 
                    icon="pi pi-trash"
                    pTooltip="Supprimer"
                    tooltipPosition="top"
                    (onClick)="deleteCredential(credential)"
                    [disabled]="loading"
                    severity="danger"
                    [text]="true"
                    size="small">
                  </p-button>
                </div>
              </td>
            </tr>
          </ng-template>

          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="5">
                <div class="empty-state">
                  <i class="pi pi-inbox"></i>
                  <h3>Aucune credential configurée</h3>
                  <p>Cliquez sur le bouton + pour ajouter une nouvelle credential</p>
                </div>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div><!-- close table-container -->
  </div>

<!-- Dialog d'ajout - Design professionnel -->
<p-dialog [(visible)]="showAddDialog" 
          [modal]="true" 
          [style]="{width: '520px'}"
          [closable]="true"
          [draggable]="false"
          [resizable]="false"
          styleClass="credential-add-dialog">
  <ng-template pTemplate="header">
    <div class="dialog-header-custom">
      <i class="pi pi-plus-circle" style="font-size: 1.3rem; color: #27ae60; margin-right: 12px;"></i>
      <div>
        <h3 style="margin: 0; color: #2c3e50; font-size: 1.2rem;">Nouvelle Credential API</h3>
        <p style="margin: 4px 0 0 0; color: #6c757d; font-size: 0.85rem;">Ajouter une clé d'API pour un utilisateur</p>
      </div>
    </div>
  </ng-template>
  
  <ng-template pTemplate="content">
    <div class="field">
      <label for="user_id">Utilisateur *</label>
      <p-dropdown 
        [options]="userOptions"
        formControlName="user_id"
        placeholder="Sélectionner un utilisateur"
        [showClear]="true"
        [filter]="true"
        filterBy="label"
        [virtualScroll]="true"
        [virtualScrollItemSize]="38">
        <ng-template pTemplate="selectedItem">
          <div *ngIf="credentialForm.get('user_id')?.value" class="flex align-items-center gap-2">
            <div class="bg-primary-100 p-1 border-round">
              <i class="pi pi-user text-primary text-sm"></i>
            </div>
            <span>{{ getUserDisplayName(credentialForm.get('user_id')?.value) }}</span>
          </div>
        </ng-template>
        <ng-template pTemplate="item" let-option>
          <div class="flex align-items-center gap-2 p-1">
            <div class="bg-primary-100 p-1 border-round">
              <i class="pi pi-user text-primary text-sm"></i>
            </div>
            <div>
              <div class="font-medium">{{ getUserName(option.value) }}</div>
              <div class="text-xs text-600">{{ getUserEmail(option.value) }}</div>
            </div>
          </div>
        </ng-template>
      </p-dropdown>
      <small class="p-error" *ngIf="credentialForm.get('user_id')?.invalid && credentialForm.get('user_id')?.touched">
        Veuillez sélectionner un utilisateur
      </small>
    </div>

    <div class="field">
      <label for="api_name">API *</label>
      <p-dropdown 
        [options]="apiNameOptions"
        formControlName="api_name"
        placeholder="Sélectionner une API"
        [showClear]="true">
      </p-dropdown>
      <small class="p-error" *ngIf="credentialForm.get('api_name')?.invalid && credentialForm.get('api_name')?.touched">
        Veuillez sélectionner une API
      </small>
      <!-- Guide des clés requises pour l'API sélectionnée -->
      <div *ngIf="currentApiKeysGuide.length > 0" class="credential-keys-guide">
        <div class="guide-title"><i class="pi pi-info-circle"></i> Clés requises pour cette API :</div>
        <div *ngFor="let entry of currentApiKeysGuide" class="guide-entry">
          <code class="guide-key">{{ entry.key }}</code>
          <span class="guide-desc">{{ entry.description }}</span>
        </div>
      </div>
    </div>

    <div class="field">
      <label for="credential_key">Clé *</label>
      <input 
        type="text" 
        pInputText 
        formControlName="credential_key"
        placeholder="Ex: api_key, client_id, etc." />
      <small class="p-error" *ngIf="credentialForm.get('credential_key')?.invalid && credentialForm.get('credential_key')?.touched">
        La clé est requise
      </small>
    </div>

    <div class="field">
      <label for="credential_value">Valeur *</label>
      <p-password 
        formControlName="credential_value"
        placeholder="Valeur de la credential"
        [feedback]="false"
        [toggleMask]="true">
      </p-password>
      <small class="p-error" *ngIf="credentialForm.get('credential_value')?.invalid && credentialForm.get('credential_value')?.touched">
        La valeur est requise
      </small>
    </div>
  </ng-template>
  <ng-template pTemplate="footer">
    <div class="dialog-footer-custom">
      <p-button label="Annuler" 
                icon="pi pi-times"
                (onClick)="showAddDialog = false; resetForm()"
                styleClass="p-button-text p-button-secondary">
      </p-button>
      <p-button label="Créer la credential"
                icon="pi pi-check"
                (onClick)="onSubmit()"
                [disabled]="credentialForm.invalid || loading"
                [loading]="loading"
                styleClass="p-button-success">
      </p-button>
    </div>
  </ng-template>
</p-dialog>

<!-- Dialog d'édition - Design professionnel -->
<p-dialog [(visible)]="showEditDialog" 
          [modal]="true" 
          [style]="{width: '520px'}"
          [closable]="true"
          [draggable]="false"
          [resizable]="false"
          styleClass="credential-edit-dialog">
  <ng-template pTemplate="header">
    <div class="dialog-header-custom">
      <i class="pi pi-pencil" style="font-size: 1.3rem; color: #e67e22; margin-right: 12px;"></i>
      <div>
        <h3 style="margin: 0; color: #2c3e50; font-size: 1.2rem;">Modifier la credential</h3>
        <p style="margin: 4px 0 0 0; color: #6c757d; font-size: 0.85rem;" *ngIf="editingCredential">
          {{ editingCredential.api_name }} &middot; {{ editingCredential.user?.username || 'Utilisateur ' + editingCredential.user_id }}
        </p>
      </div>
    </div>
  </ng-template>
  
  <ng-template pTemplate="content">
    <!-- Formulaire -->
    <form [formGroup]="editForm" (ngSubmit)="updateCredential()" class="edit-credential-form">
      <div class="form-section-cred">
        <div class="field-cred">
          <label class="field-label-cred">
            <i class="pi pi-server"></i> API
          </label>
          <p-dropdown [options]="apiNameOptions"
                      formControlName="api_name"
                      placeholder="Sélectionner une API"
                      [style]="{'width': '100%'}">
          </p-dropdown>
        </div>

        <div class="field-cred">
          <label class="field-label-cred">
            <i class="pi pi-key"></i> Clé
          </label>
          <input type="text" 
                 pInputText 
                 formControlName="credential_key"
                 placeholder="Clé de la credential"
                 class="field-input-cred" />
        </div>

        <div class="field-cred">
          <label class="field-label-cred">
            <i class="pi pi-lock"></i> Valeur
          </label>
          <p-password formControlName="credential_value"
                      placeholder="Valeur de la credential"
                      [feedback]="false"
                      [toggleMask]="true"
                      [style]="{'width': '100%'}">
          </p-password>
        </div>
      </div>
    </form>
  </ng-template>

  <ng-template pTemplate="footer">
    <div class="dialog-footer-custom">
      <p-button label="Annuler" 
                icon="pi pi-times" 
                (onClick)="cancelEdit()"
                styleClass="p-button-text p-button-secondary"></p-button>
      <p-button label="Enregistrer" 
                icon="pi pi-check" 
                (onClick)="updateCredential()"
                [disabled]="loading"
                [loading]="loading"
                styleClass="p-button-warning"></p-button>
    </div>
  </ng-template>
</p-dialog>

<!-- Dialog de filtrage par utilisateur -->
<p-dialog 
  header="Filtrer par utilisateur" 
  [(visible)]="showUserFilterDialog" 
  [modal]="true" 
  [style]="{width: '400px'}">
  
  <form [formGroup]="userFilterForm" (ngSubmit)="loadCredentialsByUser()" class="p-fluid">
    <div class="field">
      <label for="filter_user_id">Utilisateur *</label>
      <p-dropdown 
        [options]="userOptions"
        formControlName="user_id"
        placeholder="Sélectionner un utilisateur"
        [showClear]="true"
        [filter]="true"
        filterBy="label"
        [virtualScroll]="true"
        [virtualScrollItemSize]="38">
        <ng-template pTemplate="selectedItem">
          <div *ngIf="userFilterForm.get('user_id')?.value" class="flex align-items-center gap-2">
            <div class="bg-primary-100 p-1 border-round">
              <i class="pi pi-user text-primary text-sm"></i>
            </div>
            <span>{{ getUserDisplayName(userFilterForm.get('user_id')?.value) }}</span>
          </div>
        </ng-template>
        <ng-template pTemplate="item" let-option>
          <div class="flex align-items-center gap-2 p-1">
            <div class="bg-primary-100 p-1 border-round">
              <i class="pi pi-user text-primary text-sm"></i>
            </div>
            <div>
              <div class="font-medium">{{ getUserName(option.value) }}</div>
              <div class="text-xs text-600">{{ getUserEmail(option.value) }}</div>
            </div>
          </div>
        </ng-template>
      </p-dropdown>
      <small class="p-error" *ngIf="userFilterForm.get('user_id')?.invalid && userFilterForm.get('user_id')?.touched">
        Veuillez sélectionner un utilisateur
      </small>
    </div>
  </form>

  <ng-template pTemplate="footer">
    <p-button 
      label="Annuler" 
      icon="pi pi-times"
      (onClick)="showUserFilterDialog = false"
      severity="secondary"
      [text]="true">
    </p-button>
    <p-button 
      label="Filtrer"
      icon="pi pi-filter"
      (onClick)="loadCredentialsByUser()"
      [disabled]="userFilterForm.invalid || loading"
      [loading]="loading">
    </p-button>
  </ng-template>
</p-dialog>
<!-- Section Paramètres de Commission Améliorée -->
<div class="grid mt-4 mb-5">
  <div class="col-12">
    <p-card styleClass="commission-settings-card">
      <!-- En-tête -->
      <ng-template pTemplate="header">
        <div class="flex align-items-center justify-content-between p-4 border-bottom-1 surface-border">
          <div class="flex align-items-center gap-3">
            <i class="pi pi-percentage text-4xl text-primary"></i>
            <div>
              <h3 class="m-0 text-xl font-bold text-900">Paramètres de Commission</h3>
              <p class="m-0 text-sm text-600 mt-1">Configuration des taux par partenaire</p>
            </div>
          </div>
          <p-tag 
            [value]="commissionListDisplay.length + ' partenaires'" 
            severity="info" 
            icon="pi pi-users">
          </p-tag>
        </div>
      </ng-template>

      <!-- Contenu -->
      <div class="commission-content p-4">
        <div *ngIf="commissionLoading" class="flex justify-content-center align-items-center" style="min-height: 200px;">
          <i class="pi pi-spin pi-spinner text-4xl text-primary"></i>
        </div>

        <div class="grid" *ngIf="!commissionLoading && commissionListDisplay.length > 0">
          <div class="col-12 md:col-6 lg:col-4" *ngFor="let row of commissionListDisplay">
            <div class="commission-partner-card surface-card p-4 border-round-lg shadow-2 h-full hover:shadow-4 transition-all transition-duration-300">
              
              <!-- ✅ EN-TÊTE AVEC LOGO -->
              <div class="flex align-items-center justify-content-between mb-4">
                <div class="flex align-items-center gap-3">
                  <!-- Logo partenaire -->
                  <div 
                    [ngClass]="getPartnerLogoContainerClass(row.partner)" 
                    class="p-3"
                    style="width: 64px; height: 64px;">
                    <img 
                      [src]="getPartnerLogo(row.partner)"
                      [alt]="row.label + ' logo'"
                      class="partner-logo w-full h-full"
                      style="object-fit: contain;"
                      (error)="onImageError($event)" />
                  </div>
                  
                  <div>
                    <h4 class="m-0 font-bold text-lg text-900">{{ row.label }}</h4>
                    <p class="m-0 text-sm text-600 mt-1">
                      <i class="pi pi-building mr-1"></i>
                      Partenaire {{ row.partner }}
                    </p>
                  </div>
                </div>
                
                <!-- Badge statut -->
                <p-tag 
                  [value]="getPartnerStatus(row.partner)"
                  [severity]="getPartnerSeverity(row.partner)"
                  class="text-xs">
                </p-tag>
              </div>

              <!-- Séparateur -->
              <div class="border-top-1 surface-border mb-3"></div>

              <!-- Taux actuel -->
              <div class="mb-3 p-3 border-round" 
                   [ngClass]="getCurrentRateClass(row.current)"
                   style="background: rgba(var(--primary-color), 0.05);">
                <div class="flex align-items-center justify-content-between">
                  <div class="flex align-items-center gap-2">
                    <i [class]="getStatusIcon(row.current)" [ngClass]="getStatusColor(row.current)"></i>
                    <span class="text-sm font-medium text-700">Taux actuel</span>
                  </div>
                  <span class="font-bold text-lg" [ngClass]="getStatusColor(row.current)">
                    {{ getOptionLabel(row) }}
                  </span>
                </div>
                <div class="text-xs text-600 mt-1 ml-6">
                  {{ getStatusText(row.current) }}
                </div>
              </div>

              <!-- Sélecteur -->
              <div class="flex flex-column gap-2">
                <label class="text-sm font-medium text-700" [for]="'commission-' + row.partner">
                  <i class="pi pi-cog mr-1"></i>
                  Modifier le taux
                </label>

                <!-- AFIESCA: Champ numérique -->
                <div *ngIf="row.partner === 'AFIESCA'" class="flex gap-2 align-items-center">
                  <div class="p-inputgroup flex-1">
                    <input type="number" pInputText
                      [(ngModel)]="row.current"
                      min="0" max="100"
                      placeholder="15"
                      class="w-full" />
                  </div>
                  <p-button icon="pi pi-check"
                    (onClick)="onAfiescaCommissionChange(row)"
                    [disabled]="commissionLoading"
                    [loading]="commissionLoading"
                    styleClass="p-button-sm p-button-success">
                  </p-button>
                </div>

                <!-- Autres partenaires: Dropdown -->
                <p-dropdown *ngIf="row.partner !== 'AFIESCA'"
                  [id]="'commission-' + row.partner"
                  [options]="row.options"
                  [(ngModel)]="row.current"
                  (onChange)="onChangeCommission(row.partner, row.current)"
                  placeholder="Sélectionner un taux"
                  [disabled]="commissionLoading"
                  [showClear]="false"
                  optionLabel="label"
                  optionValue="value"
                  appendTo="body"
                  styleClass="w-full commission-dropdown">
                  <ng-template pTemplate="selectedItem">
                    <div class="flex align-items-center gap-2" *ngIf="row.current">
                      <i class="pi pi-check-circle text-green-500"></i>
                      <span class="font-semibold">{{ getOptionLabel(row) }}</span>
                    </div>
                    <span *ngIf="!row.current" class="text-500">Sélectionner un taux</span>
                  </ng-template>
                  <ng-template let-option pTemplate="item">
                    <div class="flex align-items-center gap-2 py-2">
                      <i class="pi pi-percentage text-primary"></i>
                      <span class="font-medium">{{ option.label }}</span>
                    </div>
                  </ng-template>
                </p-dropdown>
              </div>
            </div>
          </div>
        </div>

        <!-- Message si aucun partenaire -->
        <div *ngIf="!commissionLoading && commissionListDisplay.length === 0" 
             class="text-center text-600 py-6">
          <i class="pi pi-inbox text-6xl mb-3"></i>
          <p class="text-xl">Aucun partenaire configuré</p>
        </div>
      </div>
    </p-card>
  </div>
</div>


<!-- Toast pour les notifications -->
<p-toast></p-toast>

<!-- Confirm dialog -->
<p-confirmDialog></p-confirmDialog>